import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { SharedModule } from 'src/app/modules/shared.module';
import { AppChangelogComponent } from './app-changelog.component';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    FormsModule,
    DirectivesModule,
    SharedModule
  ],
  declarations: [AppChangelogComponent],
  exports: [AppChangelogComponent]
})
export class AppChangelogModule {}
